/**
 *
 * Asynchronously loads the component for ShareableNurturingHistoryPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShareableNurturingHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.ShareableNurturingHistoryPage,
); 